// extracted by mini-css-extract-plugin
module.exports = {"ButtonComponent":"Button-module__ButtonComponent___3jt_7","narrow":"Button-module__narrow___C4SkI","fullWidth":"Button-module__fullWidth___3uGTg"};